import { FC } from 'react';
import { Grid } from '../Grid';
import { Typography, GridProps } from '@mui/material';
import { ITooltipIconProps, renderTooltipLabel } from '../Tooltip';

export interface IReadOnlyProps {
    label?: string;
    value?: string | number;
    tooltip?: ITooltipIconProps;
    sx?: GridProps['sx'];
    testId?: string;
    stackColumns?: boolean;
}

export const ReadOnly: FC<IReadOnlyProps> = ({ label, value, tooltip, sx, testId, stackColumns = false }) => {
    const valueNode = (
        <Typography
            variant="body1"
            data-testid={testId ? `${testId}-value` : undefined}
            className="ReadOnly-value"
            sx={{ whiteSpace: 'pre-line' }}
        >
            {value}
        </Typography>
    );

    if (!label) {
        return (
            <Grid container spacing={1} columns={8} sx={sx} data-testid={testId}>
                <Grid item xs={8} md={8}>
                    {valueNode}
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container spacing={1} columns={stackColumns ? 4 : 8} sx={sx} data-testid={testId}>
            <Grid item xs={4} md={4} sx={{ margin: 'auto' }}>
                <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 'bold' }}
                    data-testid={testId ? `${testId}-label` : undefined}
                >
                    {tooltip ? renderTooltipLabel({ tooltip, label }) : label}
                </Typography>
            </Grid>
            <Grid item xs={4} md={4} sx={{ margin: 'auto' }}>
                {valueNode}
            </Grid>
        </Grid>
    );
};
